import { lazy } from "react";
import type { Routes as RoutesType } from "../../types";
import { ROUTES } from "../../constants/routes";

export const publicRoutes: RoutesType = [
  {
    key: "website.home",
    path: ROUTES.HOME_ROUTE,
    component: lazy(() => import("../../pages/website/home")),
    roles: [],
  },
  {
    key: "website.agencies",
    path: ROUTES.AGENCIES_ROUTE,
    component: lazy(() => import("../../pages/website/agencies")),
    roles: [],
  },
  {
    key: "website.agencyDetails",
    path: ROUTES.AGENCY_DETAILS_ROUTE,
    component: lazy(() => import("../../pages/website/agencies/[id]")),
    roles: [],
  },
  {
    key: "website.listings",
    path: ROUTES.LISTINGS_ROUTE,
    component: lazy(() => import("../../pages/website/listings")),
    roles: [],
  },
  {
    key: "website.listingDetails",
    path: ROUTES.LISTING_DETAILS,
    component: lazy(() => import("../../pages/website/listings/[slug]")),
    roles: [],
  },
  {
    key: "website.articles",
    path: ROUTES.ARTICLES_ROUTE,
    component: lazy(() => import("../../pages/website/articles")),
    roles: [],
  },
  {
    key: "website.articleDetails",
    path: ROUTES.ARTICLE_DETAILS_ROUTE,
    component: lazy(() => import("../../pages/website/articles/[id]")),
    roles: [],
  },
  {
    key: "website.about",
    path: ROUTES.ABOUT_ROUTE,
    component: lazy(() => import("../../pages/website/about")),
    roles: [],
  },
  {
    key: "website.contact",
    path: ROUTES.CONTACT_ROUTE,
    component: lazy(() => import("../../pages/website/contact")),
    roles: [],
  },
  {
    key: "website.privacyPolicy",
    path: ROUTES.PRIVACY_POLICY_ROUTE,
    component: lazy(() => import("../../pages/website/privacyPolicy")),
    roles: [],
  },
  {
    key: "website.emailConfirmation",
    path: ROUTES.EMAIL_CONFIRMATION_ROUTE,
    component: lazy(
      () => import("../../pages/website/user/email-confirmation")
    ),
    roles: [],
  },
  {
    key: "website.forgotPassword",
    path: ROUTES.FORGOT_PASSWORD_VERIFICATION_ROUTE,
    component: lazy(
      () => import("../../pages/website/user/forgot-password-verification")
    ),
    roles: [],
  },
  {
    key: "website.resetPassword",
    path: ROUTES.RESET_PASSWORD_ROUTE,
    component: lazy(() => import("../../pages/website/user/reset-paasowrd")),
    roles: [],
  },
  {
    key: "website.notFound",
    path: ROUTES.NOT_FOUND_ROUTE,
    component: lazy(() => import("../../pages/shared/404")),
    roles: [],
  },
];
